// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2482":"a7d3e822","2681":"b7b64bf2","4189":"a7d3e822","6677":"a7d3e822","8408":"c327e697"}[chunkId] + ".chunk.css";
};